/* eslint-disable jira/filename-case */
// Shared so workspaceResource (the resource definition) and fetchWorkspaceId (which reads the
// resolved value back out of the store) agree on the store type and key without importing each
// other — avoids the circular import that duplicated literals were previously working around.
export const RESOURCE_TYPE_SERVICEDESK_WORKSPACE_CONTEXT = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
export const WORKSPACE_CONTEXT_RESOURCE_KEY = 'state';
